import React, { useEffect, useState } from "react";
import * as ReactDOM from "react-dom";
import { useDispatch } from "react-redux";
import { Router, Switch, Route, Link } from "react-router-dom";
import "reactjs-popup/dist/index.css";
import platform from "platform";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import axios from "./api/index";
import Login from "./components/Login";
import Register from "./components/Register";
import Home from "./components/Home";
import Profile from "./components/Profile";
import Quiz from "./components/QuizScreen";
import Session from "./components/SessionScreen";
import Payment from "./components/Payment";
import Navbar from "./components/Navbar";
import { logout } from "./actions/auth";
import { clearMessage } from "./actions/message";
import { serverIP } from './api/CONSTANTS';
import { history } from "./helpers/history";
import Alert from "../src/components/Alert";

const App = () => {
  const [register, setRegister] = useState(0);
  const [login, setLogin] = useState(0);
  const [dawraImage, setDawraImage] = useState("");
  const [paymentInstructions, setPaymentInstructions] = useState("");
  const [dawraNumber, setDawraNumber] = useState("");

  const loginDetails = async () => {
    return axios({
      url: `/api/get/auth/info`,
      method: "GET",
    })
      .then((res) => {
        let data = res.data.data;
        
        // Handle both object format and array format
        if (Array.isArray(data)) {
          data.forEach((element) => {
            if (element.name === "can_register") {
              let registerValue = parseInt(element.value);
              setRegister(registerValue);
              sessionStorage.setItem("register", registerValue);
            }
            if (element.name === "can_login") {
              let loginValue = parseInt(element.value);
              setLogin(loginValue);
              sessionStorage.setItem("login", loginValue);
            }
            if (element.name === "payment_page") {
              sessionStorage.setItem("payment_page", element.value);
              setPaymentInstructions(element.value);
            }
            if (element.name === "dawra_image") {
              const imageUrl = `${serverIP}/storage/${element.value}`;
              sessionStorage.setItem("dawra_image", imageUrl);
              setDawraImage(imageUrl);
              console.log("Dawra Image URL:", imageUrl);
            }
            if (element.name === "dawra_number") {
              sessionStorage.setItem("dawra_number", element.value);
              setDawraNumber(element.value);
            }
          });
        } else {
          // Handle object format
          if (data.can_register) {
            let registerValue = parseInt(data.can_register);
            setRegister(registerValue);
            sessionStorage.setItem("register", registerValue);
          }
          if (data.can_login) {
            let loginValue = parseInt(data.can_login);
            setLogin(loginValue);
            sessionStorage.setItem("login", loginValue);
          }
          if (data.payment_page) {
            sessionStorage.setItem("payment_page", data.payment_page);
            setPaymentInstructions(data.payment_page);
          }
          if (data.dawra_image) {
            const imageUrl = `${serverIP}/storage/${data.dawra_image}`;
            sessionStorage.setItem("dawra_image", imageUrl);
            setDawraImage(imageUrl);
            console.log("Dawra Image URL:", imageUrl);
          }
          if (data.dawra_number) {
            sessionStorage.setItem("dawra_number", data.dawra_number);
            setDawraNumber(data.dawra_number);
          }
        }

      })
      .catch((err) => { });
  };

  useEffect(() => {
    loginDetails();
  }, []);

  const tokenString = sessionStorage.getItem("token");
  const userToken = JSON.parse(tokenString);

  const userString = sessionStorage.getItem("user");
  let currentUser = JSON.parse(userString);

  const dispatch = useDispatch();
  const [alertt, setAlert] = useState("");
  useEffect(() => {
    history.listen((location) => {
      dispatch(clearMessage());
    });
  }, [dispatch]);

  useEffect(() => {
    if (currentUser) {
    }
  }, [currentUser]);

  const logOut = () => {
    return axios({
      url: `/api/logout`,
      method: "POST",
    })
      .then((res) => {
        currentUser = false;
        dispatch(logout());
        sessionStorage.clear();
        window.location.reload();
      })
      .catch((err) => { });
  };

  if (!currentUser) {
    currentUser = false;
    localStorage.removeItem("user");
    history.push("/");
    sessionStorage.clear();
  }
  if (!userToken) {
    currentUser = false;
    localStorage.removeItem("user");
    history.push("/");
    sessionStorage.clear();
  }

  return (
    <Router history={history}>
      <div>
        <Navbar currentUser={currentUser} logOut={logOut} register={register} login={login} />
        <div className="">
          <Switch>
            <Route exact path={["/", "/home"]} render={() => <Home register={register} login={login} dawraImageUrl={dawraImage} dawraNumber={dawraNumber} />} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/register" component={Register} />
            <Route exact path="/profile" component={Profile} />
            <Route exact path="/session/:id" component={Session} />
            <Route exact path="/quiz" component={Quiz} />
            <Route exact path="/payment" render={() => (
              <Payment paymentInstructions={paymentInstructions} />
            )} />
          </Switch>
          <Alert />
        </div>
      </div>
    </Router>
  );
};

export default App;
